import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/base/ui/tooltip'
import {cn} from '@/lib/utils'
import {Arrow, Portal} from '@radix-ui/react-tooltip'
import React from 'react'

export interface IWuTooltipProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'content'> {
  content?: string | React.ReactNode
  duration?: number
  position?: 'top' | 'right' | 'bottom' | 'left'
  positionOffset?: number
  children: React.ReactNode
  dir?: 'rtl' | 'ltr'
  showArrow?: boolean
}

export const WuTooltip = React.forwardRef<HTMLSpanElement, IWuTooltipProps>(
  (
    {
      content,
      position,
      positionOffset,
      duration,
      children,
      className,
      showArrow = false,
      ...rest
    },
    ref,
  ): React.JSX.Element => {
    return (
      <TooltipProvider delayDuration={duration || 200}>
        <Tooltip>
          <TooltipTrigger asChild>
            <span ref={ref}>{children}</span>
          </TooltipTrigger>
          <Portal>
            {content && (
              <TooltipContent
                {...rest}
                side={position || 'top'}
                sideOffset={positionOffset || 0}
                className={cn('max-w-sm max-h-96 overflow-y-auto', className)}
              >
                {content}
                {showArrow && (
                  <Arrow className="fill-gray-notification wu-tooltip-arrow" />
                )}
              </TooltipContent>
            )}
          </Portal>
        </Tooltip>
      </TooltipProvider>
    )
  },
)

WuTooltip.displayName = 'WuTooltip'
